/* global PubSub */

/* 获取经纬度 */
function setLonLatMoveListener (params) {
  var handler = new Cesium.ScreenSpaceEventHandler(this.viewer.canvas)
  handler.setInputAction((event) => {
    /* 鼠标经过的屏幕坐标 */
    const viewer = this.viewer
    const camera = viewer.camera
    const canvas = viewer.canvas
    viewer.scene.globe.depthTestAgainstTerrain = true
    let lng
    let lat
    let height = 0
    if (viewer.scene.mode === 3) {
      /* 获取笛卡尔三维坐标 */
      const earthPosition = viewer.scene.pickPosition(event.startPosition);
      if (!earthPosition) {
        return
      }
      /* 将笛卡尔三维坐标转为地图坐标(弧度) */
      const ellipsoid = viewer.scene.globe.ellipsoid;
      const cartographic = ellipsoid.cartesianToCartographic(earthPosition);
      /* 将地图坐标(弧度)转为经纬度 */
      // 经度
      lng = Cesium.Math.toDegrees(cartographic.longitude);
      // 纬度
      lat = Cesium.Math.toDegrees(cartographic.latitude);
      // 高度
      height = ellipsoid.cartesianToCartographic(camera.position).height; // 高度
    }
    if (viewer.scene.mode === 2) {
      const ellipsoid = viewer.scene.globe.ellipsoid;
      const earthPosition = viewer.scene.camera.pickEllipsoid(event.endPosition, ellipsoid)
      const cartographic = ellipsoid.cartesianToCartographic(earthPosition);
      // 经度
      lng = Cesium.Math.toDegrees(cartographic.longitude)
      // 纬度
      lat = Cesium.Math.toDegrees(cartographic.latitude)
    }
    PubSub.publish('CESIUM_MOUSE_MOVE_GETLATLON', {
      lat: lat,
      lng: lng,
      height: height,
    })
  }, Cesium.ScreenSpaceEventType.MOUSE_MOVE)
}

function removeLonLatMoveListener (handler) {
  handler.removeInputAction(Cesium.ScreenSpaceEventType.MOUSE_MOVE)
}

/* 获取分辨率 */
function setReslutionListener () {
  this.viewer.scene.camera.moveEnd.addEventListener(() => {
    const scene = this.viewer.scene;
    /* 获取画布的大小 */
    const width = scene.canvas.clientWidth;
    const height = scene.canvas.clientHeight;
    /* 获取画布中心两个像素的坐标（默认地图渲染在画布中心位置）*/
    const left = scene.camera.getPickRay(new Cesium.Cartesian2((width / 2) | 0, (height - 1) / 2));
    const right = scene.camera.getPickRay(new Cesium.Cartesian2(1 + (width / 2) | 0, (height - 1) / 2));

    const globe = scene.globe;
    const leftPosition = globe.pick(left, scene);
    const rightPosition = globe.pick(right, scene);

    if (!Cesium.defined(leftPosition) || !Cesium.defined(rightPosition)) {
      return;
    }

    const leftCartographic = globe.ellipsoid.cartesianToCartographic(leftPosition);
    const rightCartographic = globe.ellipsoid.cartesianToCartographic(rightPosition);
    const geodesic = new Cesium.EllipsoidGeodesic();
    geodesic.setEndPoints(leftCartographic, rightCartographic);
    /* 分辨率 */
    const distance = geodesic.surfaceDistance;

    PubSub.publish('CESIUM_ZOOM_CHANGE_GET_RESLUTION', Math.round(distance))
  })
}

export { setLonLatMoveListener, removeLonLatMoveListener, setReslutionListener }
